import firebase from "firebase/app"
import "firebase/auth"

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBRN7tGZHJWO8qZd3Mk5vk94KlWigB5Kgc",
  authDomain: "smart-kassa.firebaseapp.com",
  databaseURL: "https://smart-kassa.firebaseio.com",
  projectId: "smart-kassa",
  storageBucket: "",
  messagingSenderId: "800902148446",
  appId: "1:800902148446:web:1138e7486e08b1f00d1fcf",
}

firebase.initializeApp(config)

export default firebase
